"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var country_json_1 = __importDefault(require("./lib/country.json"));

var state_json_1 = __importDefault(require("./lib/state.json"));

var city_json_1 = __importDefault(require("./lib/city.json"));

var _findEntryByCode = function _findEntryByCode(source, code) {
  if (code && source != null) {
    var codex = source.findIndex(function (c) {
      return c.isoCode === code;
    });
    return codex !== -1 ? source[codex] : '';
  }

  return '';
};

var _findStateByCodeAndCountryCode = function _findStateByCodeAndCountryCode(source, code, countryCode) {
  if (code && countryCode && source != null) {
    var codex = source.findIndex(function (c) {
      return c.isoCode === code && c.countryCode === countryCode;
    });
    return codex !== -1 ? source[codex] : '';
  }

  return '';
};

var compare = function compare(a, b) {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
};

exports.default = {
  getStatesOfCountry: function getStatesOfCountry(countryCode) {
    var states = state_json_1.default.filter(function (value) {
      return value.countryCode === countryCode;
    });
    return states.sort(compare);
  },
  getCitiesOfState: function getCitiesOfState(countryCode, stateCode) {
    var cities = city_json_1.default.filter(function (value) {
      return value.countryCode === countryCode && value.stateCode === stateCode;
    });
    return cities.sort(compare);
  },
  getCitiesOfCountry: function getCitiesOfCountry(countryCode) {
    var cities = city_json_1.default.filter(function (value) {
      return value.countryCode === countryCode;
    });
    return cities.sort(compare);
  },
  getAllCountries: function getAllCountries() {
    return country_json_1.default;
  },
  getAllStates: function getAllStates() {
    return state_json_1.default;
  },
  getAllCities: function getAllCities() {
    return city_json_1.default;
  },
  getCountryByCode: function getCountryByCode(isoCode) {
    return _findEntryByCode(country_json_1.default, isoCode);
  },
  // to be deprecate
  getStateByCode: function getStateByCode(isoCode) {
    // eslint-disable-next-line no-console
    console.warn("WARNING! 'getStateByCode' has been deprecated, please use the new 'getStateByCodeAndCountry' function instead!");
    return _findEntryByCode(state_json_1.default, isoCode);
  },
  getStateByCodeAndCountry: function getStateByCodeAndCountry(isoCode, countryCode) {
    return _findStateByCodeAndCountryCode(state_json_1.default, isoCode, countryCode);
  }
};